type VoEResponseAccessInput = {
  status?: string | null
  responseContent?: { voeResponseContentId?: string | null } | null
} | null

export const canViewVoEResponse = (voe: VoEResponseAccessInput): boolean =>
  Boolean(
    voe?.responseContent?.voeResponseContentId ||
      voe?.status === 'COMPLETED' ||
      voe?.status === 'PENDING_REVIEW'
  )
